import { useCurrentUser } from "@/lib/me";
import { useOrganizerClubs } from "@/lib/clubs/queries";
import type { AppSurface } from "@/components/UserMenu/UserMenu";

interface AccessibleSurfacesResult {
  isLoading: boolean;
  surfaces: AppSurface[];
  organizerClubCount: number;
  isStaff: boolean;
  isFacilitator: boolean;
}

/**
 * Derives which top-level surfaces (cockpit / operator / facilitator) the
 * signed-in user can access. Used by the dispatcher at `/` and by the
 * `UserMenu` switcher in each surface chrome.
 */
export function useAccessibleSurfaces(): AccessibleSurfacesResult {
  const me = useCurrentUser();
  const clubs = useOrganizerClubs();

  const isLoading = me.isLoading || clubs.isLoading;
  const organizerClubCount = clubs.data?.length ?? 0;
  const isStaff = Boolean(me.data?.isAdmin);
  const isFacilitator = Boolean(me.data?.isFacilitator);

  const surfaces: AppSurface[] = [];
  if (organizerClubCount > 0) surfaces.push("cockpit");
  if (isStaff) surfaces.push("operator");
  if (isFacilitator) surfaces.push("facilitator");

  return { isLoading, surfaces, organizerClubCount, isStaff, isFacilitator };
}
